import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { SOURCE_APP_MESSAGES } from 'automation-ui-source-apps/constants/SourceAppMessages';
const isValidMessageKey = (sourceApp, key) => {
  return SOURCE_APP_MESSAGES[sourceApp] && SOURCE_APP_MESSAGES[sourceApp][key] && isValidI18nKey(`automation-ui-source-apps.${key}.${sourceApp}`);
};
const getSourceAppKey = (sourceApp, key) => {
  if (!isValidMessageKey(sourceApp, key)) {
    return null;
  }
  return `automation-ui-source-apps.${key}.${sourceApp}`;
};
const getSourceAppText = (sourceApp, key) => {
  const sourceAppKey = getSourceAppKey(sourceApp, key);
  if (!sourceAppKey) {
    return null;
  }
  return I18n.text(sourceAppKey);
};
const getSourceAppMessage = (sourceApp, key) => {
  if (!isValidMessageKey(sourceApp, key)) {
    return null;
  }
  return SOURCE_APP_MESSAGES[sourceApp][key];
};
export const getSourceAppNameText = sourceApp => {
  return getSourceAppText(sourceApp, 'name');
};
export const getSourceAppNameInPhraseText = sourceApp => {
  return getSourceAppText(sourceApp, 'nameInPhrase');
};
export const getSourceAppNameMessage = sourceApp => {
  return getSourceAppMessage(sourceApp, 'name');
};
export const getSourceAppNameInPhraseMessage = sourceApp => {
  return getSourceAppMessage(sourceApp, 'nameInPhrase');
};